import { Box } from "@mui/material";
import AppFooter from "../../components/footer";
import Header from "../../components/header";
import ServiceProducts from "./ServiceProducts";
import Services from "./Services";

const AllServices = () => {
  return (
    <>
      <Box
        height={"100vh"}
        sx={{
          background: (theme) => theme.palette.gradient.background,
        }}
      >
        <Header />
      </Box>
      <Services />
      <ServiceProducts />
      <AppFooter />
    </>
  );
};

export default AllServices;
